import React from 'react';
import { Box } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

import gvLogo from '../images/gvLogo.png';
import black_logo from '../images/black_logo.png';

import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';

import { Menu } from '@mui/material';
import { MenuItem } from '@mui/material';
import { Typography } from '@mui/material';
import { TextField } from '@mui/material';
import { Button } from '@mui/material';

import Modal from '@mui/material/Modal';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 375,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function AppHeader() {

  // For Menu
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // For Modal

  const [openModal, setOpenModal] = React.useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const addKey = () => {
    console.log('Add key to list');
    handleCloseModal();
  }

  const location = useLocation();

  return (

    <Box sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      // marginTop: '10px',
      marginTop: '5px',
      paddingBottom: 0,
      paddingLeft: '10px',
      paddingRight: '10px',
    }}>

      <Box
        sx={{
          width: '10%',
        }}
      >
        {/* <Link to={'#'}> */}
        <MenuIcon
          fontSize={'large'}
          sx={{
            color: location.pathname == '/settings' ||
              location.pathname == '/profile' ||
              location.pathname == '/home'
              || location.pathname == '/about'
              || location.pathname == '/privacy-statement'
              || location.pathname == '/help'
              ? '#FFFFFF' : '#3B4E68',
          }}
          onClick={handleClick}
        />
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          <MenuItem onClick={handleClose}>
            <Link
              to='/about'
              style={{
                textDecoration: 'none'
              }}
            >
              About
            </Link>
          </MenuItem>
          <MenuItem onClick={handleClose}>
            <Link
              to='/help'
              style={{
                textDecoration: 'none'
              }}
            >
              Help
            </Link>
          </MenuItem>
        </Menu>
        {/* </Link> */}
      </Box>

      <Box
        sx={{
          width: '50%',
        }}
      >
        <img
          src={location.pathname == '/settings' ||
            location.pathname == '/profile' ||
            location.pathname == '/home' ||
            location.pathname == '/about' ||
            location.pathname == '/privacy-statement' ||
            location.pathname == '/help' ? gvLogo : black_logo}
          alt="gridvault logo"
          className='home-icon'
          style={{
            width: '100%'
          }}
        />
      </Box>

      <Box
        sx={{
          width: '10%',
        }}
      >
        <Link to={'#'}>
          <SearchIcon
            fontSize={'large'}
            sx={{
              color: location.pathname == '/settings' ||
                location.pathname == '/profile' ||
                location.pathname == '/home'
                || location.pathname == '/about'
                || location.pathname == '/privacy-statement'
                || location.pathname == '/help'
                ? '#FFFFFF' : '#3B4E68',
            }}
          />
        </Link>
      </Box>

      <Box
        sx={{
          width: '10%',
        }}
      >
        {/* <Link to={'#'}> */}
        <AddIcon
          fontSize={'large'}
          sx={{
            color: location.pathname == '/settings' ||
              location.pathname == '/profile' ||
              location.pathname == '/home'
              || location.pathname == '/about'
              || location.pathname == '/privacy-statement'
              || location.pathname == '/help'
              ? '#FFFFFF' : '#3B4E68',
          }}
          onClick={handleOpenModal}
        />
        <Modal
          open={openModal}
          onClose={handleCloseModal}
        >
          <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2"
              sx={{
                color: '#3B4E68',
                paddingBottom: '20px',
              }}
            >
              Enter Key Information
            </Typography>
            <Box
              sx={{
                paddingBottom: '10px',
                width: '100%',
              }}
            >
              <TextField
                label="Name of key"
                variant="filled"
                sx={{
                  "& .MuiFilledInput-root": {
                    backgroundColor: '#3B4E6801',
                    "&:after": {
                      // borderColor: "secondary.main",
                      // borderWidth: "3px",
                    },
                  },
                  "& .MuiInputLabel-filled": {
                    color: '#3B4E68',
                    "&.Mui-focused": {
                      // color: "secondary.main",
                      // fontWeight: "bold",
                    },
                  },
                }}
                slotprops={{
                  inputLabel: {
                    shrink: true,
                  },
                }}
              />
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                // margin: '20px',
                padding: '20px',
                // paddingRight: '20px',
                // paddingLeft: '20px',
                // paddingBottom: '20px',
                // borderBottom: '2px solid grey',
              }}>
              <Box
                sx={{
                  width: '45%',
                }}
              >
                <Button
                  variant="contained"
                  sx={{
                    width: '100%',
                    backgroundColor: '#3B4E68',
                    color: '#FFFFFF',
                    '&:hover': {
                      color: '#3B4E68',
                      border: '1px solid #3B4E68',
                      backgroundColor: '#60A5FA',
                    }
                  }}
                  onClick={handleCloseModal}
                >
                  Cancel
                </Button>
              </Box>
              <Box
                sx={{
                  width: '45%',
                }}
              >
                <Button
                  variant="contained"
                  sx={{
                    width: '100%',
                    backgroundColor: '#3B4E68',
                    color: '#FFFFFF',
                    '&:hover': {
                      color: '#3B4E68',
                      border: '1px solid #3B4E68',
                      backgroundColor: '#60A5FA',
                    }
                  }}
                  onClick={addKey}
                >
                  Add key
                </Button>
              </Box>
            </Box>
          </Box>
        </Modal>
        {/* </Link> */}
      </Box>

    </Box >
  );

}